import React, { FC, useEffect, useState } from 'react'
import { Link } from '@ally/metronome-ui'
import { useHostServices } from '../HostServices'
import { getTransferTicket } from '../utils/transferTicket'
import { Error } from './Error'
import { Loader } from './Loader'
import { autoBaseUrl } from '../constants'

function getDestinationURL(ticketID: string): string {
  const { pathname, searchParams } = new URL(window.location.toString())
  searchParams.append('ticketID', ticketID)
  const destination = pathname.replace(/^\/sso\/auto/, '') ?? '/'
  return `${autoBaseUrl}/#/auto${destination}?${searchParams.toString()}`
}

export const Auto: FC = () => {
  const {
    transmitRef,
    session,
    log: { track },
  } = useHostServices()
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    track('ally-next-remote-sso-auto-init')
    getTransferTicket(transmitRef, session.data)
      .then(ticketID => {
        const destination = getDestinationURL(ticketID)
        track('ally-next-remote-sso-auto-done')
        window.location.replace(destination)
      })
      .catch(() => {
        track('ally-next-remote-sso-auto-error')
        setFailed(true)
      })
  }, [])

  return (
    <>
      <Loader description="We're taking you to your auto accounts." />
      {failed && (
        <Error
          errorMessage={
            <>
              We&apos;ve hit a roadblock on the way to your auto accounts.
              We&apos;re working on a fix, so try again in a bit.{' '}
              <Link to="/dashboard" variant="link" text="Go to Snapshot" />
            </>
          }
        />
      )}
    </>
  )
}
